import React from "react";
import Column from "canvas-core-react/lib/Column";
import Row from "canvas-core-react/lib/Row";
import Card from "canvas-core-react/lib/Card";
import Margin from "canvas-core-react/lib/Margin";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import TextBody from "canvas-core-react/lib/TextBody";
import IconHighAmountIllustrative from "canvas-core-react/lib/IconHighAmountIllustrative";
import IconWithdrawIllustrative from "canvas-core-react/lib/IconWithdrawIllustrative";
import IconSavingsIllustrative from "canvas-core-react/lib/IconSavingsIllustrative";
import IconPaymentScheduleIllustrative from "canvas-core-react/lib/IconPaymentScheduleIllustrative";
import "./style.scss";

interface TitleTextRichProps {
  title: string;
  contenido: string[];
}

export const TitleTextRich = ({ title, contenido }: TitleTextRichProps) => {
  const chooseIcon = (index: number) => {
    switch (index) {
      case 1:
        return <IconHighAmountIllustrative />;
      case 2:
        return <IconWithdrawIllustrative />;
      case 3:
        return <IconPaymentScheduleIllustrative />;
      case 4:
        return <IconSavingsIllustrative />;
    }
  };

  return (
    <Card className="titleTextRich">
      {title && (
        <Margin xs={6} sm={6} md={6} lg={6}>
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <TextSubtitle component="span">{title}</TextSubtitle>
            </Column>
          </Row>
          <Row><br></br></Row>
        </Margin>
      )}
      {contenido.length > 0 && (
        <Margin xs={6} sm={6} md={6} lg={6}>
          {contenido.map((value: string, index: number) => {
            let contentSplatted = value.split(":");
            return (<div key={index}>
              <Row>

                <Column
                  className="titleTextRich__icons"
                  xs={4}
                  sm={1}
                  md={1}
                  lg={1}
                >
                  {chooseIcon(index + 1)}
                </Column>
                <Column
                  className="titleTextRich__message"
                  xs={4}
                  sm={7}
                  md={11}
                  lg={11}
                >
                  <TextSubtitle component="span">
                    {contentSplatted[0]}:
                  </TextSubtitle>
                  <TextBody component="span">
                    {""}
                    {contentSplatted[1]}
                  </TextBody>
                </Column>
              </Row>
              <Row><br></br></Row></div>
            );
          })}
        </Margin>
      )}
    </Card>
  );
};
